'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
import moment from "moment";
var ngModule = getNgModule(__filename);
ngModule.controller('CheckEcheanceEditionController', function ($scope, $translate, $q, $http, UUID, $modal, $notifications, arrayUtils, $dateFormat, $dialogBox, tlTableUtils, lovService) {
  // On travaille sur une copie
  $scope.editedEcheance = _objectSpread({}, $scope.echeance);
  $q.when(lovService.getValidationStates()).then(function (validationStates) {
    $scope.validationStates = _.reject(validationStates, function (state) {
      return state.id === 'NON_VERIFIE';
    });
  });
  $scope.saving = false;
  $scope.validateAndSave = function () {
    $scope.saving = true;
    $scope.echeance.validation = $scope.editedEcheance.validation;
    $scope.echeance.numeroMandat = $scope.editedEcheance.numeroMandat;
    $scope.echeance.validationUser = null;
    $scope.echeance.validationDate = null;
    $http.post('/rest/evenementsGestionProduit/' + $scope.produitId + '/validationEcheance/', $scope.echeance).then(function (response) {
      $scope.$close();
    }).finally(function () {
      $scope.saving = false;
    });
  };

  // Utilitaires
  $scope.formatDate = function (value) {
    return $dateFormat.short(value);
  };
  $scope.formatePointage = function (model) {
    var pointage = "";
    pointage += "Pointé par ";
    pointage += model.validationUser ? model.validationUser : "vous-même";
    pointage += model.validationDate ? " le " + $dateFormat.short(model.validationDate) : " à l'instant";
    return pointage;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/checkEcheance/checkEcheanceEdition.js
// module id = 2686
// module chunks = 13